"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Sauna = function Sauna(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-259.000000, -5685.000000)",
    stroke: fill,
    strokeWidth: "1.75"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(260.000000, 5686.000000)"
  }, /*#__PURE__*/_react["default"].createElement("line", {
    x1: "0",
    y1: "18.5",
    x2: "7",
    y2: "18.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.7072994,15.3932567 L15.4912134,20.3092952 C15.7364266,20.743103 16.1870856,21.006785 16.6714702,21 C17.1558548,20.9929493 17.5993591,20.7164972 17.8329893,20.2758507 C18.0666194,19.8352042 18.0543911,19.2982327 17.800964,18.8695449 L14.625506,13.2746605 C14.3820443,12.8535181 13.943678,12.5958425 13.4706307,12.5958145 L8.9148902,12.5958145 L6.59346517,7.77395667 C6.38464057,7.34039412 5.97450725,7.05001635 5.50953479,7.00652502 C5.04370207,6.95937738 4.58832354,7.17012078 4.31065572,7.56135106 L0.269490288,13.1562355 C-0.1768845,13.7742293 -0.0562650675,14.6509496 0.538901334,15.114445 C1.13406774,15.5779404 1.9784037,15.4526946 2.42477852,14.8347008 L5.15840242,11.0544239 L6.87724478,14.6202302 C7.10552216,15.0941375 7.57210298,15.3934154 8.08241012,15.3932567 L9.42946526,15.3932567 L9.42946526,19.58942 C9.42946526,20.3619124 10.0325624,20.9881411 10.7765204,20.9881411 C11.5204784,20.9881411 12.1235755,20.3619124 12.1235755,19.58942 L12.1235755,15.3932567 L12.7072994,15.3932567 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,2.5 C4,3.39316397 4.47649728,4.21848152 5.24999998,4.66506351 C6.02350268,5.1116455 6.97649732,5.1116455 7.75000002,4.66506351 C8.52350272,4.21848152 9,3.39316397 9,2.5 C9,1.60683604 8.52350273,0.781518487 7.75000002,0.334936495 C6.97649732,-0.111645498 6.02350268,-0.111645498 5.24999998,0.334936495 C4.47649727,0.781518487 4,1.60683604 4,2.5 L4,2.5 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.6682359,0 C21.0285909,2.73619048 17.6319634,2.26761905 19.6682359,5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6682359,0 C18.0285909,2.73619048 14.6319634,2.26761905 16.6682359,5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.6682359,0 C14.0285909,2.73619048 10.6319634,2.26761905 12.6682359,5"
  })))));
};
Sauna.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Sauna.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Sauna;